import React, { useState, useEffect } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { useAuth } from '../../hooks/auth';
import { ContainerAlert } from './styles';
import Language from '../../language/language.json';

interface AlertEmailInterface {
  email: string;
}

const AlertEmail: React.FC<AlertEmailInterface> = ({ email }) => {
  const { languageStorage } = useAuth();
  const [isUpper, setIsUpper] = useState(false);
  const [textAlert, setTextAlert] = useState<string>();

  useEffect(() => {
    if (email !== email.toLowerCase()) {
      setIsUpper(true);
      setTextAlert(
        Language[languageStorage][
          'Seu e-mail possui letra maiuscula, por favor verifique se esta correto'
        ],
      );
    } else if (email.match(/[áàãâäéèêëíìîïóòõôöúùûü]/)) {
      setIsUpper(true);
      setTextAlert(
        Language[languageStorage][
          'Seu e-mail possui acento, por favor verifique se está correto'
        ],
      );
    } else if (email.match(/[ç]/)) {
      setIsUpper(true);
      setTextAlert(
        `${Language[languageStorage]['Seu e-mail possui']} "ç", ${Language[languageStorage]['por favor verifique se está correto']}`,
      );
    } else {
      setIsUpper(false);
    }
  }, [email, languageStorage]);
  return (
    <>
      {isUpper && (
        <ContainerAlert>
          <FiAlertCircle />
          <p>{textAlert}</p>
        </ContainerAlert>
      )}
    </>
  );
};
export default AlertEmail;
